export default __webpack_public_path__ + "static/media/safari_settings_ipad.888f2e94.png";